import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{attrs:{"color":_vm.color,"timeout":"5000"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},_vm._l((_vm.content),function(message,index){return _c('div',{key:index,staticClass:"subtitle-2"},[_vm._v(" "+_vm._s(message)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }